import { render, staticRenderFns } from "./StatisticTableFooter.vue?vue&type=template&id=b5de4aa4&scoped=true"
import script from "./StatisticTableFooter.vue?vue&type=script&lang=js"
export * from "./StatisticTableFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5de4aa4",
  null
  
)

export default component.exports